// extracted by mini-css-extract-plugin
export default {"container":"lx2yO3","iconWrapper":"lgkvJ3"};